import { useTranslation } from 'react-i18next';
import {
  MAX_AGE,
  MIN_AGE,
  MAX_FOLLOWERS,
  MIN_FOLLOWERS,
  GENDER_OPTIONS,
  MIN_MAX_AGE_OPTIONS,
  MIN_MAX_FOLLOWERS_OPTIONS
} from '@anytag/shared-constants';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { CheckBoxesField, RangeSliderInputField } from '../rhf-fields';
import { SimilarInfluencerPopperFilterFormKeys } from './types';

export const Template = () => {
  const { t } = useTranslation();
  const genderOptions = useTranslateOptions(GENDER_OPTIONS);

  return (
    <div className="w-70 p-4 shadow-container">
      <CheckBoxesField<SimilarInfluencerPopperFilterFormKeys>
        name="genders"
        options={genderOptions}
        title={t('General.Gender')}
      />
      <RangeSliderInputField<SimilarInfluencerPopperFilterFormKeys>
        title={t('General.Age')}
        options={MIN_MAX_AGE_OPTIONS}
        slideProps={{ min: MIN_AGE, max: MAX_AGE }}
        minField={{ name: 'minAge', placeholder: '18-' }}
        maxField={{ name: 'maxAge', placeholder: '50+' }}
      />
      <RangeSliderInputField<SimilarInfluencerPopperFilterFormKeys>
        options={MIN_MAX_FOLLOWERS_OPTIONS}
        title={t('General.Number of Followers')}
        slideProps={{ step: 10000, min: MIN_FOLLOWERS, max: MAX_FOLLOWERS }}
        minField={{ name: 'minFollowers', placeholder: '0' }}
        maxField={{ name: 'maxFollowers', placeholder: '1,000,000+' }}
      />
    </div>
  );
};
